var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGlobe = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "89px",
    viewBox: "0 0 101 89",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "12F9B3BD-48E7-47A1-B350-48BFBE9F8436")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-New-Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---03",
    transform: "translate(-1131.000000, -562.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.86
  }, /*#__PURE__*/React.createElement("g", {
    id: "Template---Secondary-Bar",
    transform: "translate(254.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(16.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(176.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-Copy-6",
    transform: "translate(407.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Index-Replication"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(279.000000, 109.000000)",
    id: "globe"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.3816425,2.82125604 C29.4364045,5.4783001 22.198279,9.93737025 16.2222222,15.8561709 C19.077221,18.6677815 22.227968,21.1558405 25.6182255,23.2753623 C28.0139009,15.6716139 32.0290551,8.68988027 37.3816425,2.82125604 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7161212,73.1019244 L46.7161212,64.8586567 C46.725747,62.0625331 47.6588791,59.3469911 49.3719807,57.1304348 L26.0966184,57.1304348 C26.2523291,64.270355 27.2259461,71.369421 28.9982177,78.2898551 C34.5893667,75.633763 40.5703588,73.8823821 46.7161212,73.1019244 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9806763,27.6269031 C19.8934443,25.2251542 16.1077526,22.343509 12.7040876,19.0434783 C5.00999085,28.1620739 0.543849556,39.5681843 0,51.4879227 L20.633125,51.4879227 C20.7785105,43.4280468 21.9024852,35.4155086 23.9806763,27.6269031 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2222222,93.4818304 C22.1856428,99.4294519 29.4295663,103.887151 37.3816425,106.502415 C32.0180156,100.642707 27.9841201,93.6611037 25.5628774,86.0483092 C22.1873403,88.1665496 19.054267,90.6597125 16.2222222,93.4818304 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6042368,57.1304348 L0,57.1304348 C0.546470866,69.0535415 5.00541358,80.4606412 12.6828073,89.5748792 C16.0840736,86.2434896 19.8780541,83.3417282 23.9806763,80.9341669 C21.8957926,73.1668718 20.7619432,65.1732925 20.6042368,57.1304348 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1932367,85.7017367 L52.1932367,85.5647467 C49.7971648,83.7608043 48.0896458,81.1943321 47.3528594,78.2898551 C41.4291087,79.0760336 35.6766298,80.8358508 30.3285024,83.497495 C34.2050788,95.0441684 40.1756188,103.484485 46.9594831,107.207729 C46.9594831,107.044207 46.9118274,106.89395 46.9118274,106.727832 L46.9118274,96.180753 C46.9239579,92.0525945 48.8804419,88.1707297 52.1932367,85.7017367 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1014493,15.8561709 C87.1253925,9.93708187 79.887267,5.4783001 71.942029,2.82125604 C77.2963292,8.68930353 81.3134817,15.6710372 83.7105845,23.2753623 C87.0991291,21.1555522 90.2481634,18.6677815 93.1014493,15.8561709 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6839607,51.4879227 L109.323671,51.4879227 C108.781916,39.5690347 104.316901,28.1632077 96.6231833,19.0434783 C93.2184318,22.3437925 89.4315318,25.2251542 85.3429952,27.6269031 C87.4190147,35.4157921 88.5410802,43.4283303 88.6839607,51.4879227 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1304348,0 L57.1304348,31.0338164 C64.4817687,30.6673406 71.6821824,28.7737866 78.2898551,25.4695008 C73.6679907,11.4999668 65.92,1.62570065 57.1304348,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4879227,31.0338164 L51.4879227,0 C42.6983575,1.62568568 34.9503668,11.4998609 30.3285024,25.4692662 C36.9361751,28.7735216 44.1365888,30.6670581 51.4879227,31.0338164 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1932367,35.9742057 C44.1884077,35.6199766 36.3355528,33.700719 29.092884,30.3285024 C27.269767,37.2447002 26.2643337,44.3447705 26.0966184,51.4879227 L52.1932367,51.4879227 L52.1932367,35.9742057 L52.1932367,35.9742057 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2307875,30.3285024 C72.9881187,33.7010006 65.1352638,35.6202582 57.1304348,35.9742057 L57.1304348,51.4879227 L83.2270531,51.4879227 C83.0593378,44.3447705 82.0539045,37.2447002 80.2307875,30.3285024 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 70.178744,
    cy: 70.178744,
    r: 2.46859903
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.182675,57.1304348 L60.010562,57.1304348 C55.6933487,57.1304348 52.1932367,60.6355204 52.1932367,64.9595059 L52.1932367,75.397982 C52.1932367,79.7216821 55.6930637,83.2270531 60.010562,83.2270531 L138.182675,83.2270531 C142.499888,83.2270531 146,79.7219675 146,75.397982 L146,64.9595059 C146,60.6355204 142.499888,57.1304348 138.182675,57.1304348 Z M70.4333774,78.0076724 C66.1161641,78.0076724 62.6160521,74.5025868 62.6160521,70.1786012 C62.6160521,65.8549012 66.1158791,62.3495301 70.4333774,62.3495301 C74.7505906,62.3495301 78.2507026,65.8546157 78.2507026,70.1786012 C78.2507026,74.5025868 74.7508756,78.0076724 70.4333774,78.0076724 Z M114.730984,72.7882916 L109.519434,72.7882916 C108.080458,72.7882916 106.913659,71.6200249 106.913659,70.1786012 C106.913659,68.737463 108.080173,67.5689109 109.519434,67.5689109 L114.730984,67.5689109 C116.16996,67.5689109 117.336759,68.7371776 117.336759,70.1786012 C117.336759,71.6200249 116.16996,72.7882916 114.730984,72.7882916 Z M130.365349,72.7882916 L125.153799,72.7882916 C123.714823,72.7882916 122.548024,71.6200249 122.548024,70.1786012 C122.548024,68.737463 123.714538,67.5689109 125.153799,67.5689109 L130.365349,67.5689109 C131.804326,67.5689109 132.971125,68.7371776 132.971125,70.1786012 C132.971125,71.6200249 131.804611,72.7882916 130.365349,72.7882916 Z",
    id: "Shape"
  })))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGlobe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/globe.005921a8.svg";
export { ForwardRef as ReactComponent };